import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState } from "react";
import { Icon } from "@blueprintjs/core";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";
import { ImageContainer } from "../components/ImageContainer";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page8 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  const [comments, setComments] = useState<any>(weekData?.page8?.comment ?? "");
  const onTitleUpdated = (text: string) => {
    setComments(text);
    onPageDataUpdated("page8", "comment", text);
  };
  useEffect(() => {
    registerPageIndex(
      pageIndex,
      subIndex,
      "HAFTALIK SENTİMENT DEĞERLENDİRMESİ SONUÇ"
    );
  }, []);
  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="HAFTALIK SENTİMENT DEĞERLENDİRMESİ SONUÇ" />

      <div
        style={{
          width: "100%",
          height: "100%",
          paddingInline: "14px",
          fontSize: "28px",
        }}
      >
        <div
          style={{
            backgroundColor: "#F7AF3D",
            padding: "5px 10px",
            fontWeight: "600",
            marginBottom: "10px",
            borderRadius: "2px",
            fontSize: "20px",
          }}
        >
          Haftalık Sentiment Değerlendirme Sonuç
        </div>
        <TextArea
          className="no-print"
          style={{ flex: 1, width: "100%", height: "80%", fontSize: "28px" }}
          placeholder="Haftalık Sentiment Değerlendirme Sonucunu girebilirisiniz"
          onChange={(e) => onTitleUpdated(e.target.value)}
          defaultValue={comments}
        />
        <div
          className="print-only-block"
          style={{ color: "black", fontSize: 28, lineHeight: "42px" }}
        >
          <p>
            {comments
              ?.split("\n")
              .filter((item: string) => item.trim() !== "")
              .map((item: string) => (
                <p>{item}</p>
              ))}
          </p>
        </div>
      </div>
      <ImageContainer
        pageId={"page8"}
        onPageDataUpdated={onPageDataUpdated}
        weekData={weekData?.page8}
      />
    </WeeklyPage>
  );
};
